/** Admin section tabs — shared by admin pages and Organisation settings. */
export const ADMIN_TABS = [
  { title: 'Users', link: '/Portal/Instructor/admin/users' },
  { title: 'Course Catalog', link: '/Portal/Instructor/admin/catalog' },
  { title: 'Integrations', link: '/Portal/Instructor/admin/integrations' },
  { title: 'Location & Standard', link: '/Portal/Instructor/admin/location' },
  { title: 'Plan & billing', link: '/Portal/Instructor/admin/billing' },
];

export const SYSTEM_TABS = [
  { title: 'Setting', link: '/Portal/Instructor/setting' },
  { title: 'Packages', link: '/Portal/Instructor/packages' },
  { title: 'Application users', link: '/Portal/Instructor/system/users' },
  { title: 'Campaigns', link: '/Portal/Instructor/system/campaigns' },
  { title: 'Activation codes', link: '/Portal/Instructor/system/activation-codes' },
  { title: 'Import catalog', link: '/Portal/Instructor/ImportCourse' },
  { title: 'Publishing', link: '/Portal/Instructor/system/publishing' },
  { title: 'Demo access', link: '/Portal/Instructor/system/demo-access' },
  { title: 'Prompts', link: '/Portal/Instructor/system/prompts' },
  { title: 'Question type selection', link: '/Portal/Instructor/system/question-selection' },
];
